import React from 'react';
import HearingDescriptionTag, { Evaluation } from '../../elements/HearingDescriptionTag';
import { createUseStyles } from 'react-jss';

interface SoundRatingProps {
  sound: string[];
  speechComprehension: string[];
  volume: string[];
}

const attributeMapping: Record<string, { description: string; evaluation: Evaluation }> = {
  clear: { description: 'Klar', evaluation: 'positive' },
  natural: { description: 'Natürlich', evaluation: 'positive' },
  precise: { description: 'Präzise', evaluation: 'positive' },
  muted: { description: 'Gedämpft', evaluation: 'neutral' },
  booming: { description: 'Dröhnend', evaluation: 'neutral' },
  distorted: { description: 'Verzerrt', evaluation: 'negative' },
  tinny: { description: 'Blechern', evaluation: 'negative' },
  clearly: { description: 'Deutlich', evaluation: 'positive' },
  understandable: { description: 'Verständlich', evaluation: 'positive' },
  mostlyUnderstandable: { description: 'Überwiegend zu verstehen', evaluation: 'neutral' },
  incomprehensible: { description: 'Unverständlich', evaluation: 'negative' },
  choppy: { description: 'Abgehackt', evaluation: 'negative' },
  pleasant: { description: 'Angenehm', evaluation: 'positive' },
  balanced: { description: 'Ausgewogen', evaluation: 'positive' },
  tooLoud: { description: 'Zu laut', evaluation: 'negative' },
  tooQuiet: { description: 'Zu leise', evaluation: 'negative' },
  swaying: { description: 'Schwankend', evaluation: 'neutral' },
  unpleasant: { description: 'Unangenehm', evaluation: 'negative' },
  okay: { description: 'In Ordnung', evaluation: 'neutral' },
  artificial: { description: 'Künstlich', evaluation: 'negative' },
  indistinct: { description: 'Undeutlich', evaluation: 'negative' },
};

const SoundRating: React.FC<SoundRatingProps> = ({ sound, speechComprehension, volume }) => {
  const classes = useStyles();

  const renderTags = (attributes: string[]) => {
    return (
      <div className={classes.tagContainer}>
        {attributes.map(attribute => {
          const mapping = attributeMapping[attribute];
          if (!mapping) return null;
          return (
            <HearingDescriptionTag key={Math.random()} evaluation={mapping.evaluation}>
              {mapping.description}
            </HearingDescriptionTag>
          );
        })}
      </div>
    );
  };

  return (
    <div className={classes.container}>
      Klang:
      {renderTags(sound)}
      Verständlichkeit:
      {renderTags(speechComprehension)}
      Lautstärke:
      {renderTags(volume)}
    </div>
  );
};

const useStyles = createUseStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: 5,
  },
  tagContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 5,
  },
});

export default SoundRating;
